import http from "@/shared/services/http";

export const singleLocation = (id: number) => http.get(`v1/locations/${id}`);
export const listLocation = (params) => http.get(`v1/locations`, {params});
export const deleteLocation = (id: number) => http.delete(`v1/locations/${id}`);
export const deleteLocations = (data: any) => http.delete(`v1/locations/list`, {data});
